import classNames from 'classnames';
import type { RefObject } from 'react';
import type { ChangeEvent, FC, FormEvent, KeyboardEvent } from 'react';
import './TextAreaInput.css';

export interface TextAreaInputProps {
  autoFocus?: boolean;
  className?: string;
  hasError?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: (e: FormEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: FormEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
  readOnly?: boolean;
  value: string;
  inputRef?: RefObject<HTMLTextAreaElement>;
  name?: string;
}

export const TextAreaInput: FC<TextAreaInputProps> = (props) => (
  <textarea
    autoFocus={props.autoFocus}
    className={classNames(
      'text-area-input',
      props.disabled && 'text-area-input--disabled',
      props.hasError && 'text-area-input--error',
      props.className,
    )}
    disabled={props.disabled}
    value={props.value}
    onChange={props.onChange}
    placeholder={props.placeholder}
    ref={props.inputRef}
    name={props.name}
    onFocus={props.onFocus}
    onBlur={props.onBlur}
    onKeyDown={props.onKeyDown}
    readOnly={props.readOnly}
  />
);
